exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".assets-sidebar-content {\n  padding: 16px;\n}\n.assets-sidebar-content .content-controls {\n  border-top: 1px solid #eee;\n  padding-top: 16px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-column-gap: 10px;\n}\n.assets-sidebar-content .content-controls.remove {\n  grid-template-columns: repeat(2, 1fr) 40px;\n}\n.assets-sidebar-content .tags-dropdown-input:read-only {\n  background: white;\n}\n.assets-sidebar-content .assets-drop-down {\n  width: 100%;\n  float: unset;\n  position: relative;\n}\n", ""]);

// exports
